function isEnterKey(e) {
  return e.keyCode === 13;
}

function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

export { isEnterKey, deepClone };
